import { API } from '@/api';
import type { LD_CLAIM_DUPLICATE_STATUS } from '@/contants/ClaimsEnums';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface CheckDuplicatePreClaimRequestParams {
  claimKey: number;
  freightBillNo: number;
  invoiceNo: number;
}

export const checkDuplicatePreClaimAPI = (params: CheckDuplicatePreClaimRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/CheckDuplicateClaim`,
    method: 'get',
    params,
  });
};

export type CheckDuplicatePreClaimResponse = (typeof LD_CLAIM_DUPLICATE_STATUS)[keyof typeof LD_CLAIM_DUPLICATE_STATUS];

export const checkDuplicatePreClaim = async (
  params: CheckDuplicatePreClaimRequestParams,
): Promise<CheckDuplicatePreClaimResponse> => {
  const response: AxiosResponse<CheckDuplicatePreClaimResponse> = await checkDuplicatePreClaimAPI(params);
  return response.data;
};
